import React from "react";
import bg_image from "../assets/images/comparison_bg.svg";
import homeIcon from "../assets/images/homeicon_compare.svg";

const BreadCrumb = ({ title, desc }) => {
  return (
    <div
      className="bg-cover bg-center text-white p-6 md:p-12 rounded-lg sm:rounded-none my-10"
      style={{ backgroundImage: `url(${bg_image})` }}
    >
      <div className="flex items-center text-sm md:text-base font-semibold">
        <img src={homeIcon} alt="/home-icon" className="mr-2" />
        <span>/ {title}</span>
      </div>
      <h1 className="text-4xl mt-5 font-bold">{title}</h1>
      {desc && <p>{desc}</p>}
    </div>
  );
};

export default BreadCrumb;
